import Lara from "@/presets/lara";

const buttonDefaultPt = Lara.button;

export const downloadButtonPt = {
  root: (options) => ({
    class: [
      ...buttonDefaultPt.root(options).class,
      "!h-9 !px-4 !text-xs !font-bold !uppercase !tracking-wider",
      "!border !border-teal-900 !bg-white !text-teal-900",
      "hover:!bg-teal-900 hover:!text-white",
      // Without these the disabled button still inverts on hover, since the
      // single-pseudo-class hover rules above would otherwise apply.
      "disabled:!border-gray-400 disabled:!bg-white disabled:!text-gray-600",
      "disabled:hover:!bg-white disabled:hover:!text-gray-600",
    ],
  }),
};
